module.exports = __webpack_public_path__ + "static/media/facebook.fe4a6c43.svg";